import { adminWatchers } from "./adminSaga";
import { appWatchers } from "./appSaga";
import { searchWatchers }  from "./searchSaga";

export const allWatchers = [ ...appWatchers, ...searchWatchers, ...adminWatchers ];